export const ExplorePlansIllustration = () => {
  return (
    <svg
      width="287"
      height="243"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M249.785 100.5c-11.319 8.467-31.524 7.885-47.417-7.997-16.102-16.091-17.121-39.65-8.523-51.249-.388.4-.742.815-1.06 1.246-14.465 15.567-12.372 41.47 1.97 55.803 15.944 14.759 41.13 16.047 55.03 2.197Z"
        fill="#EEF6FD"
      />
      <path
        d="m267.081 41.083.515-.213-.214-.514-.963-2.317v-.001a.757.757 0 0 1-.058-.29.762.762 0 0 1 1.124-.658.766.766 0 0 1 .345.375l.961 2.317.213.513.514-.212 2.317-.957a.766.766 0 0 1 .972.995.765.765 0 0 1-.387.41l-2.316.957-.515.213.214.514.964 2.32.004.008.004.009a.773.773 0 0 1 .015.594.75.75 0 0 1-.419.425.769.769 0 0 1-1.009-.438l-.004-.01-.004-.008-.964-2.32-.212-.51-.513.21-2.324.954a.77.77 0 0 1-1-.41.765.765 0 0 1 .415-.995l2.325-.961ZM143.081 58.083l.515-.213-.214-.514-.963-2.317v-.001a.757.757 0 0 1-.058-.29.762.762 0 0 1 1.124-.658.766.766 0 0 1 .345.375l.961 2.317.213.513.514-.212 2.317-.957a.766.766 0 0 1 .972.995.765.765 0 0 1-.387.41l-2.316.957-.515.213.214.514.964 2.32.004.008.004.009a.773.773 0 0 1 .015.594.75.75 0 0 1-.419.425.769.769 0 0 1-1.009-.438l-.004-.01-.004-.008-.964-2.32-.212-.51-.513.21-2.324.954a.77.77 0 0 1-1-.41.765.765 0 0 1 .415-.995l2.325-.961ZM210.081 143.083l.515-.213-.214-.515-.963-2.316v-.001a.758.758 0 0 1-.058-.29.759.759 0 0 1 .617-.734.768.768 0 0 1 .852.451l.961 2.317.213.513.514-.212 2.317-.957a.766.766 0 0 1 .967.425.764.764 0 0 1 .005.57.768.768 0 0 1-.387.41l-2.316.957-.515.213.214.514.964 2.319.004.009.004.009a.77.77 0 0 1 .015.594.754.754 0 0 1-.419.425.767.767 0 0 1-1.009-.438l-.004-.009-.004-.009-.964-2.319-.212-.512-.513.211-2.324.954a.768.768 0 0 1-1-.41.764.764 0 0 1 .415-.995l2.325-.961Z"
        fill="#E74A36"
        stroke="#E74A36"
      />
      <path
        d="M260.126 91.41c.798-1.267-.305-2.817-1.721-2.58a45.925 45.925 0 0 1-11.92.419c-25.367-2.402-44.906-25.017-42.5-50.437.144-1.52.359-3.015.643-4.483.272-1.414-1.254-2.55-2.539-1.783-11.169 6.662-19.131 18.411-20.455 32.394-2.2 23.234 14.762 43.857 37.902 46.048 16.315 1.545 32.355-6.493 40.59-19.577Z"
        stroke="#E74A36"
        strokeWidth="3"
      />
      <path
        d="M193.654 9.179a.826.826 0 0 1-.835.834c-4.141 0-7.515 3.371-7.515 7.51a.826.826 0 0 1-.835.834.838.838 0 0 1-.835-.834c0-4.139-3.373-7.51-7.514-7.51a.837.837 0 0 1-.835-.834c0-.468.384-.835.835-.835 4.141 0 7.514-3.37 7.514-7.51 0-.467.385-.834.835-.834.468 0 .835.367.835.834 0 4.14 3.374 7.51 7.515 7.51.468 0 .835.367.835.835ZM162.654 122.179a.826.826 0 0 1-.835.834c-4.141 0-7.515 3.371-7.515 7.51a.826.826 0 0 1-.835.834.838.838 0 0 1-.835-.834c0-4.139-3.373-7.51-7.514-7.51a.837.837 0 0 1-.835-.834c0-.468.384-.835.835-.835 4.141 0 7.514-3.371 7.514-7.51 0-.467.385-.834.835-.834.468 0 .835.367.835.834 0 4.139 3.374 7.51 7.515 7.51.468 0 .835.367.835.835ZM286.654 122.179a.826.826 0 0 1-.835.834c-4.141 0-7.515 3.371-7.515 7.51a.826.826 0 0 1-.835.834.838.838 0 0 1-.835-.834c0-4.139-3.373-7.51-7.514-7.51a.837.837 0 0 1-.835-.834c0-.468.384-.835.835-.835 4.141 0 7.514-3.371 7.514-7.51 0-.467.385-.834.835-.834.468 0 .835.367.835.834 0 4.139 3.374 7.51 7.515 7.51.468 0 .835.367.835.835Z"
        fill="#E6F5FF"
      />
      <rect
        x="94.285"
        y="127.788"
        width="16.829"
        height="9.963"
        rx="3"
        transform="rotate(-23.79 94.285 127.788)"
        fill="#EEF6FD"
      />
      <rect
        x="1.285"
        y="183.422"
        width="24.349"
        height="7.835"
        rx="3"
        transform="rotate(-23.79 1.285 183.422)"
        fill="#EEF6FD"
      />
      <path
        fill="#EEF6FD"
        d="m18.635 169.492 44.577-19.65 3.923 8.9-44.576 19.65z"
      />
      <path
        fill="#EEF6FD"
        d="m58.775 147.087 39.567-17.443 4.445 10.083L63.22 157.17z"
      />
      <rect
        x="96.262"
        y="128.556"
        width="13.829"
        height="37.945"
        rx="1.5"
        transform="rotate(-23.79 96.262 128.556)"
        stroke="#E74A36"
        strokeWidth="3"
      />
      <rect
        x="60.752"
        y="147.855"
        width="40.241"
        height="31.741"
        rx="1.5"
        transform="rotate(-23.79 60.752 147.855)"
        stroke="#E74A36"
        strokeWidth="3"
      />
      <rect
        x="20.613"
        y="170.26"
        width="45.716"
        height="23.651"
        rx="1.5"
        transform="rotate(-23.79 20.613 170.26)"
        stroke="#E74A36"
        strokeWidth="3"
      />
      <rect
        x="3.262"
        y="184.19"
        width="21.349"
        height="13.164"
        rx="1.5"
        transform="rotate(-23.79 3.262 184.19)"
        stroke="#E74A36"
        strokeWidth="3"
      />
      <rect
        x="1.33"
        y="181.685"
        width="1.586"
        height="19.132"
        rx=".793"
        transform="rotate(-23.79 1.33 181.685)"
        stroke="#E74A36"
        strokeWidth="1.586"
      />
      <rect
        x="72.311"
        y="185.602"
        width="1.586"
        height="60.501"
        rx=".793"
        transform="rotate(-21.29 72.311 185.602)"
        stroke="#E74A36"
        strokeWidth="1.586"
      />
      <rect
        x="63.007"
        y="184.024"
        width="1.586"
        height="60.501"
        rx=".793"
        transform="rotate(21.017 63.007 184.024)"
        stroke="#E74A36"
        strokeWidth="1.586"
      />
      <rect
        x="113.535"
        y="240.75"
        width="1.5"
        height="90.5"
        rx=".75"
        transform="rotate(90 113.535 240.75)"
        stroke="#E74A36"
        strokeWidth="1.5"
      />
      <circle
        cx="68.285"
        cy="175"
        r="10.5"
        fill="#fff"
        stroke="#E74A36"
        strokeWidth="3"
      />
      <circle
        cx="92.785"
        cy="237.5"
        r="4.3"
        fill="#fff"
        stroke="#E74A36"
        strokeWidth="2.4"
      />
    </svg>
  );
};
